/**
 * Author: Valeria Sinnati
 * ᓚᘏᗢ  Button del design system, grammatica della BI: pillola piena.
 *
 * Il primario è un riempimento verde con testo `on-accent` (Deep Purple),
 * piatto e senza gradiente: nel brand book il verde è un colore pieno, e un
 * gradiente verso un verde più scuro lo faceva sembrare sporco. Il ghost è
 * la pillola `soft` (Light Purple in chiaro, viola pannello in scuro).
 */
import type { ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'ghost' | 'danger'

const base =
  'inline-flex min-h-11 items-center justify-center gap-2 rounded-pill px-5 py-2.5 text-sm font-bold ' +
  'transition-all duration-200 ease-out-quint active:scale-[0.97] ' +
  'disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100 ' +
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-ink'

const variants: Record<Variant, string> = {
  primary: 'text-on-accent bg-accent hover:brightness-105',
  ghost: 'text-foreground bg-soft hover:bg-panel-3',
  danger: 'text-on-danger bg-danger hover:brightness-110',
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
}

/**
 *  /\____/\
 * > •    • <   #1
 */
export function Button({ variant = 'primary', className = '', ...props }: ButtonProps) {
  return <button className={`${base} ${variants[variant]} ${className}`} {...props} />
}
